export const baseUrl = process.env.PORT || 'http://localhost:4000';